export enum ERPMessageType {
None,
Information,
Warning,
Error,
}
